import { Radio } from 'antd';
import './style.css';
import React from 'react';

/**
 * Props for the RadioButtonCard component.
 */
interface RadioButtonCardProps {
  /** Icon displayed inside the card. */
  icon: React.ReactNode;
  /** Title text displayed on the card. */
  title?: string;
  /** Callback function triggered when the radio button value changes. */
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Description text displayed below the title. */
  description?: string;
  /** Value associated with the radio button. */
  value: string | number;
}

/**
 * A card-styled radio button component with an icon, title, and description.
 *
 * @param {RadioButtonCardProps} props - The component props.
 * @returns {JSX.Element} The rendered RadioButtonCard component.
 */
const RadioButtonCard: React.FC<RadioButtonCardProps> = ({ icon, title = '', onChange, description = '', value }) => {
  return (
    <div
      id="radioButtonCardWrapper"
      className="radioButtonCardWrapper"
      onClick={() => onChange({ target: { value } } as React.ChangeEvent<HTMLInputElement>)}
    >
      <div className="radioButtonCardTopView">
        {icon}
        <Radio style={{ width: '16px', height: '16px' }} value={value} />
      </div>
      <div className="radioButtonCardTitle">{title}</div>
      <div className="radioButtonCardDescription">{description}</div>
    </div>
  );
};

export default RadioButtonCard;
